import React from 'react';
import { Card } from '@indigo-ag/component-module';

interface Props {
  padding?: string;
  className?: string;
  style?: any;
}

export const EnhancedPaper: React.FunctionComponent<Props> = ({
  children,
  padding = '24px',
  style = {},
  ...rest
}): JSX.Element => {
  return (
    <Card as="div" style={{ overflowX: 'auto', padding, ...style }} {...rest}>
      {children}
    </Card>
  );
};
